import Model from 'src/app/common/model';
import TestCategoryModel from './testCategory.model';
import QpTypeModel from './qpType.model';

export default class QueryParamsModel extends Model {
  testCategory: TestCategoryModel;
  qpType: QpTypeModel;
  name?: string;
  abbreviation: string;
  description: string;
  uom?: string;
  unit_code?: string;
  is_derived?: string;
  test_category_id: number;
  qp_type_id: number;
  created_name: string;
  updated_name: string;

  constructor() {
    super();
  }
}
